/* eslint-disable @typescript-eslint/ban-ts-comment */

import { datadogRum } from '@datadog/browser-rum';
import { DatadogProvider } from '@datadog/openfeature-browser';

import { getDatadogEnvironment } from './env-helper';

export const DATADOG_SERVICE_NAME = 'eppo-frontend';

let isInitialized = false;

export function isDatadogRumInitialized() {
  return isInitialized;
}

export function initDatadogRum() {
  if (isInitialized) {
    return;
  }

  const datadogAppId = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
  const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
  if (datadogAppId && datadogClientToken) {
    datadogRum.init({
      applicationId: datadogAppId,
      clientToken: datadogClientToken,
      site: 'datadoghq.com',
      service: 'eppo-frontend',
      env: process.env.NEXT_PUBLIC_APP_ENV,
      version: process.env.NEXT_PUBLIC_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: process.env.NEXT_PUBLIC_API_BASE_URL
        ? [process.env.NEXT_PUBLIC_API_BASE_URL]
        : undefined,
      enableExperimentalFeatures: ['feature_flags'],
    });

    datadogRum.startSessionReplayRecording();

    isInitialized = true;
  }
}

export function createDatadogOpenFeatureProvider(): DatadogProvider | null {
  const datadogAppId = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
  const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

  if (!datadogAppId || !datadogClientToken) {
    console.warn('Datadog app ID or client token not found');
    return null;
  }

  return new DatadogProvider({
    clientToken: datadogClientToken,
    applicationId: datadogAppId,
    service: DATADOG_SERVICE_NAME,
    env: getDatadogEnvironment(),
    flaggingProxy: process.env.DATADOG_FLAGS_CONFIG_PROXY_URL,
    enableExposureLogging: true,
    enableFlagEvaluationTracking: true,
    rum: {
      sdk: datadogRum,
      ddFlaggingTracking: true,
    },
  });
}
